import { Link } from 'react-router-dom'
import Price from '../../ui/price'
import { toPersianDateTime } from '../../utils/gmt-to-local-persian-date'
import { ProductImage } from 'utils/imageUtils'

const STATUS_LITERALS = {
  checkout: 'پرداخت نشده',
  'payment-succeed': 'در حال پردازش و بسته‌بندی',
  'partially-fulfilled': 'بخشی از سفارش پردازش شد',
  fulfilled: 'آماده‌ی ارسال',
  'partially-shipped': 'بخشی از سفارش ارسال شد',
  shipped: 'ارسال شد',
  completed: 'دریافت شده توسط گیرنده',
  declined: 'رد شد',
}

interface OrderStatusTypes {
  checkout?: string
  'payment-succeed'?: string
  'partially-fulfilled'?: string
  fulfilled?: string
  'partially-shipped'?: string
  shipped?: string
  completed?: string
  declined?: string
}

interface Product {
  image?: string | ProductImage // Old format: string, or Cart/Order format: ProductImage object
  images?: ProductImage[] // New format: array of image objects
  title: string
}

interface StatusHistoryType {
  status: OrderStatusTypes | string
  changedAt: string | number | Date
}

interface OrderItems {
  discount: number
  id: string
  orderId: string
  ownerId: string
  product: Product
  productId: string
  quantity: number
  shipmentTrackingCode: number | null
  status: string
  statusHistory: StatusHistoryType[]
  subTotal: number
  total: number
  vat: number
}

interface Order {
  createdAt: string
  currency: string
  customerId: string
  discount: number
  id: string
  items: OrderItems[]
  receiverFirstName: string
  receiverLastName: string
  receiverTelephone: string
  shipmentTrackingCode: number | null
  shippingAddressCityId: number
  shippingAddressLatitude: number | null
  shippingAddressLongitude: number | null
  shippingAddressPostalCode: string
  shippingAddressText: string
  shippingPrice: number
  status: string
  statusHistory: StatusHistoryType[]
  subTotal: number
  total: number
  vat: number
}

export const OrderItem = ({ order }: { order: Order }) => {
  let statuses = order.items.map(({ status }) => status)

  let orderStatus
  let allAreTheSame = statuses.every((status) => status === statuses[0])
  if (allAreTheSame) {
    orderStatus = statuses[0]
  } else {
    orderStatus = 'payment-succeed'
  }

  let paymentSucceedStatusChange = order.statusHistory.find(
    (item) => (item.status = 'payment-succeed'),
  )
  const changedAt = paymentSucceedStatusChange?.changedAt
  let paymentSucceedDate = new Date(changedAt as number)
  return (
    <li key={order.id}>
      <Link
        className='flex justify-around my-4 border border-solid rounded-md overflow-hidden p-4'
        style={{ backgroundColor: 'var(--card-bg)', borderColor: 'var(--accent-primary)', color: 'var(--text-primary)' }}
        to={`/orders/${order.id}`}
      >
        <div className='w-1/4'>{order.id.split('-')[0]}</div>
        <div className='w-1/4'>{toPersianDateTime(paymentSucceedDate)}</div>
        <div className='w-1/4'>
          <Price
            value={order.total}
            currencyCode={order.currency}
            alternativeCurrencyCode={true}
          />
        </div>
        {orderStatus ? (
          <div className='w-1/4'>
            {STATUS_LITERALS[orderStatus as keyof OrderStatusTypes]}
          </div>
        ) : null}
      </Link>
    </li>
  )
}
